import { direccionGeneralData } from '@/mocks/nosotros-data';

export default function DireccionGeneral() {
  const { name, role, bio, funciones } = direccionGeneralData;

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-5xl mx-auto">
          <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600 mb-3">
            Gestión ejecutiva
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-10 md:mb-14">
            Dirección General
          </h2>

          <div className="rounded-2xl bg-background-100 border border-secondary-200/60 overflow-hidden">
            <div className="grid grid-cols-1 md:grid-cols-5">
              {/* Image — larger, refined treatment */}
              <div className="md:col-span-2 relative h-[300px] md:h-[480px] overflow-hidden">
                <img
                  src="https://storage.helloreaddy.io/project_files/b36b426b-b2cb-46b2-8bd1-3f029dd7b0e4/2f3b2312-2aee-4806-bb37-33f9a2e141ec_compressed_maritza-Rojas.webp"
                  alt={name}
                  className="w-full h-full object-cover object-center"
                />
                {/* Subtle gradient overlay on the image */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background-100 hidden md:block" />
              </div>

              {/* Info — executive leadership */}
              <div className="md:col-span-3 p-6 md:p-8 lg:p-10 flex flex-col justify-center">
                <span className="inline-block px-3 py-1 rounded-full bg-foreground-900 text-white text-xs font-semibold mb-3 whitespace-nowrap w-fit">
                  {role}
                </span>
                <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
                  {name}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-8">
                  {bio}
                </p>

                {/* Funciones */}
                <div>
                  <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
                    Funciones principales
                  </h4>
                  <ul className="space-y-3">
                    {funciones.map((fn, i) => (
                      <li key={i} className="flex items-start gap-3 text-sm text-foreground-600 group">
                        <span className="w-1.5 h-1.5 rounded-full bg-primary-500 mt-1.5 shrink-0 group-hover:scale-150 transition-transform duration-200" />
                        <span className="leading-relaxed">{fn}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}